// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"130":"4afafdf3","296":"ea88be26"}[chunkId] || chunkId) + "." + {"83":"8eb3fe0f3baa4253","130":"257b163d3883e3a0","296":"4031e8dca9c09163","610":"db04d04bff083d3c"}[chunkId] + ".js";
};